$('.destinationmodal').modaal({
	width: 500
});